"use strict";
(globalThis["webpackChunkweb"] = globalThis["webpackChunkweb"] || []).push([[8829],{

/***/ 37695:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CK: () => (/* binding */ monoFontFamily),
/* harmony export */   Kc: () => (/* binding */ primitivesLight),
/* harmony export */   NK: () => (/* binding */ EditLayout),
/* harmony export */   Nj: () => (/* binding */ EditLightProductionTheme),
/* harmony export */   PW: () => (/* binding */ EditLightTheme),
/* harmony export */   Rv: () => (/* binding */ EditDarkProductionTheme),
/* harmony export */   f8: () => (/* binding */ editOverrides),
/* harmony export */   rH: () => (/* binding */ proseFamily),
/* harmony export */   sb: () => (/* binding */ primitivesDark),
/* harmony export */   wM: () => (/* binding */ EditDarkTheme),
/* harmony export */   yR: () => (/* binding */ defaultSemanticOverrides)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70531);
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92539);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88469);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _primitives__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75580);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1898);
/* eslint-disable @typescript-eslint/no-empty-object-type */ 



const monoFontFamily = `Inconsolata, Monaco, monospace`;
const proseFamily = `Inter, -apple-system, BlinkMacSystemFont, sans-serif`;
const editOverrides = {
    name: "edit",
    borders: {
        radius200: "4px",
        radius300: "8px",
        radius400: "10px",
        radius500: "12px",
        checkboxBorderRadius: "4px"
    },
    grid: {
        columns: [
            4,
            8,
            12
        ],
        gutters: [
            16,
            16,
            16
        ],
        margins: [
            0,
            12,
            24
        ]
    },
    lighting: {
        ..._primitives__WEBPACK_IMPORTED_MODULE_1__/* .gadgetShadows */ .Ro,
        shadow400: "0px 1px 0px rgba(0, 0, 0, 0.07);",
        shadow700: "-2px 2px 0px rgba(0, 0, 0, 0.07);"
    },
    typography: (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .generateTypography */ .l8)({
        primaryFamily: monoFontFamily,
        monoFamily: monoFontFamily
    }, _primitives__WEBPACK_IMPORTED_MODULE_1__/* .productTypography */ .uQ)
};
var SemanticType;
(function(SemanticType) {
    SemanticType[SemanticType["Development"] = 0] = "Development";
    SemanticType[SemanticType["Production"] = 1] = "Production";
})(SemanticType || (SemanticType = {}));
const getSemanticOverrides = (type, colors)=>{
    const developmentOverrides = {
        colors: {
            ...colors,
            themedAlpha50: colors.alpha50,
            themedAlpha100: colors.alpha100,
            themedAlpha200: colors.alpha200,
            themedAlpha300: colors.alpha300,
            themedAlpha400: colors.alpha400,
            themedAlpha500: colors.alpha500,
            themedAlpha600: colors.alpha600,
            themedAlpha700: colors.alpha700,
            themedPrimary50: colors.primary50,
            themedPrimary100: colors.primary100,
            themedPrimary200: colors.primary200,
            themedPrimary300: colors.primary300,
            themedPrimary400: colors.primary400,
            themedPrimary500: colors.primary500,
            themedPrimary600: colors.primary600,
            themedPrimary700: colors.primary700,
            accent100: colors.electricBlue100,
            accent200: colors.electricBlue200,
            accent300: colors.electricBlue300,
            accent400: colors.electricBlue400,
            accent500: colors.electricBlue500,
            accent600: colors.electricBlue600,
            accent700: colors.electricBlue700,
            contentSecondary: colors.primary500,
            contentSecondaryOriginal: colors.primary600,
            contentAccent: colors.electricBlue500,
            contentInfo: colors.cyan700,
            contentNegative: colors.red500,
            contentWarning: colors.yellow700,
            contentPositive: colors.green700,
            contentDevelopment: colors.development,
            contentProduction: colors.purple500,
            contentDisabledDevelopment: colors.disabledDevelopment,
            backgroundTertiary: colors.primary50,
            backgroundQuaternary: colors.primary200,
            backgroundQuinary: colors.primary300,
            backgroundInverseTertiary: colors.primary700,
            backgroundInfo: colors.cyan50,
            backgroundNegative: colors.red50,
            backgroundWarning: colors.yellow50,
            backgroundPositive: colors.green50,
            backgroundSubtleBlue: colors.electricBlue50,
            backgroundProduction: "#C5ADFA36",
            border: colors.alpha300,
            borderFocus: colors.electricBlue500,
            borderSelected: colors.electricBlue400,
            borderOpaque: colors.alpha300,
            borderAlt: colors.primary200,
            borderInfo: colors.cyan500,
            borderNegative: colors.red500,
            borderError: colors.red500,
            borderWarning: colors.yellow600,
            borderPositive: colors.green200,
            buttonPrimaryFill: colors.primary700,
            buttonPrimaryHover: colors.primary600,
            buttonSecondaryFill: colors.neutralMin,
            buttonSecondaryHover: colors.primary50,
            buttonTertiaryHover: colors.alpha0,
            inputFill: "rgba(0, 0, 0, 0.01)",
            inputFillActive: colors.neutralMin,
            inputBorder: colors.primary300,
            inputBorderError: colors.red500,
            linkText: colors.primary700,
            linkVisited: colors.primary700,
            linkHover: colors.primary600,
            contentLinkText: colors.blue500,
            contentLinkHover: colors.blue600,
            contentLinkActive: colors.blue700,
            menuFontDefault: colors.neutralMax,
            tickBorderError: colors.red500,
            tickFillErrorSelected: colors.red500,
            tickFillErrorSelectedHover: colors.red600,
            tickFillErrorSelectedHoverActive: colors.red700,
            backgroundEnvironmentSettingsCallout: colors.backgroundEnvironmentSettingsCalloutDevelopment,
            contentEnvironmentSettingsCallout: colors.contentEnvironmentSettingsCalloutDevelopment
        },
        borders: {
            buttonBorderRadius: "6px",
            inputBorderRadius: "6px",
            popoverBorderRadius: "6px",
            surfaceBorderRadius: "8px",
            tableBorderRadius: "8px"
        }
    };
    if (type == 1) {
        const productionOverrides = {
            colors: {
                themedAlpha50: colors.purpleAlpha50,
                themedAlpha100: colors.purpleAlpha100,
                themedAlpha200: colors.purpleAlpha200,
                themedAlpha300: colors.purpleAlpha300,
                themedAlpha400: colors.purpleAlpha400,
                themedAlpha500: colors.purpleAlpha500,
                themedAlpha600: colors.purpleAlpha600,
                themedAlpha700: colors.purpleAlpha700,
                themedPrimary50: colors.purple50,
                themedPrimary100: colors.purple100,
                themedPrimary200: colors.purple200,
                themedPrimary300: colors.purple300,
                themedPrimary400: colors.purple400,
                themedPrimary500: colors.purple500,
                themedPrimary600: colors.purple600,
                themedPrimary700: colors.purple700,
                contentSecondaryOriginal: colors.purple600,
                contentInfo: colors.purple600,
                backgroundTertiary: colors.purple50,
                backgroundQuaternary: colors.purple100,
                backgroundQuinary: colors.purple300,
                backgroundInverseTertiary: colors.purple700,
                backgroundInfo: colors.purple50,
                borderFocus: colors.purple500,
                borderSelected: colors.purple400,
                borderOpaque: colors.purple200,
                borderAlt: colors.purple200,
                borderInfo: colors.purple200,
                tableStripedBackground: colors.purple50,
                backgroundEnvironmentSettingsCallout: colors.backgroundEnvironmentSettingsCalloutProduction,
                contentEnvironmentSettingsCallout: colors.contentEnvironmentSettingsCalloutProduction
            },
            borders: {
                // NOTE: These colours are opaque, while the default border colours are transparent
                border100: {
                    borderColor: colors.purple50
                },
                border200: {
                    borderColor: colors.purple100
                },
                border300: {
                    borderColor: colors.purple200
                },
                border400: {
                    borderColor: colors.purple300
                },
                border500: {
                    borderColor: colors.purple400
                },
                border600: {
                    borderColor: colors.purple500
                }
            }
        };
        return lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({}, developmentOverrides, productionOverrides);
    } else {
        return developmentOverrides;
    }
};
// PRIMITIVE OVERRIDES ////////////////////////////////////////////////////////
const primitivesLight = {
    ...(0,_primitives__WEBPACK_IMPORTED_MODULE_1__/* .getPrimitiveColors */ .zG)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .gadgetColorsLight */ .d_)
};
const primitivesDark = {
    ...(0,_primitives__WEBPACK_IMPORTED_MODULE_1__/* .getPrimitiveColors */ .zG)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .gadgetColorsDark */ .Ql)
};
// COLOR PALETTE OVERRIDES ////////////////////////////////////////////////////
const defaultSemanticOverrides = getSemanticOverrides(0, _primitives__WEBPACK_IMPORTED_MODULE_1__/* .gadgetColorsLight */ .d_);
const EditLightTheme = (0,baseui__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(primitivesLight, lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({}, defaultSemanticOverrides, editOverrides));
const EditLightProductionTheme = (0,baseui__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(primitivesLight, lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({}, getSemanticOverrides(1, _primitives__WEBPACK_IMPORTED_MODULE_1__/* .gadgetColorsLight */ .d_), editOverrides));
const EditDarkTheme = (0,baseui__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(primitivesDark, lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({}, getSemanticOverrides(0, _primitives__WEBPACK_IMPORTED_MODULE_1__/* .gadgetColorsDark */ .Ql), editOverrides));
const EditDarkProductionTheme = (0,baseui__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(primitivesDark, lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({}, getSemanticOverrides(1, _primitives__WEBPACK_IMPORTED_MODULE_1__/* .gadgetColorsDark */ .Ql), editOverrides));
// for debugging, its nice to be able to just see the theme values easily
if (false) {}
const EditLayout = {
    smallSubNavigationWidth: "368px",
    mediumSubNavigationWidth: "392px",
    minimumEditPaneWidth: "432px",
    maximumEditPaneWidth: "816px",
    connectionsIndexWidth: "1048px",
    connectionsModalWidth: "900px",
    appSettingIndexWidth: "1150px",
    resizablePaneStartWidth: 526
};


/***/ }),

/***/ 74888:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   s: () => (/* binding */ Column)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10334);

const Column = (0,baseui__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", (props)=>({
        display: "flex",
        flexDirection: "column",
        justifyContent: props.$align,
        gap: props.$gap,
        "data-testid": props.dataTestId
    }));


/***/ }),

/***/ 3287:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  rJ: () => (/* binding */ BetaPill),
  Tq: () => (/* binding */ FailurePill),
  FK: () => (/* binding */ PendingPill),
  DR: () => (/* binding */ Pill),
  lA: () => (/* binding */ RetryingPill),
  PS: () => (/* binding */ RunningPill),
  sP: () => (/* binding */ ScheduledPill),
  Wg: () => (/* binding */ SuccessPill),
  MA: () => (/* binding */ WarningPill)
});

// UNUSED EXPORTS: InfoPill, NewPill, PillContainer

// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/styles/styled.js
var styled = __webpack_require__(10334);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isObject.js
var isObject = __webpack_require__(93702);
var isObject_default = /*#__PURE__*/__webpack_require__.n(isObject);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/omit.js
var omit = __webpack_require__(73352);
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/CloseIcon.tsx
var CloseIcon = __webpack_require__(33619);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/icon/styled-components.js
var styled_components = __webpack_require__(74995);
;// CONCATENATED MODULE: ../@gadgetinc/widgets/src/icons/ErrorInfoIcon.tsx




const ErrorInfoIcon = (props)=>{
    const [_, $theme] = (0,styled/* useStyletron */.hQ)();
    return /*#__PURE__*/ react.createElement(styled_components/* Svg */.n, {
        viewBox: "0 0 20 20",
        ...omit_default()(props, "color")
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M9.99992 2C9.44554 2 8.97063 2.33782 8.76945 2.81901L1.53377 15.2982V15.2995C1.40319 15.5098 1.33375 15.7524 1.33325 16C1.33325 16.3536 1.47373 16.6928 1.72378 16.9428C1.97382 17.1929 2.31296 17.3333 2.66659 17.3333C2.69787 17.3331 2.72914 17.3318 2.76034 17.3294L2.76294 17.3333H9.99992H17.2369L17.2395 17.3281C17.2707 17.331 17.3019 17.3327 17.3333 17.3333C17.6869 17.3333 18.026 17.1929 18.2761 16.9428C18.5261 16.6928 18.6666 16.3536 18.6666 16C18.6663 15.752 18.5969 15.5089 18.4661 15.2982L18.4556 15.2799C18.4552 15.2795 18.4548 15.2791 18.4543 15.2786L11.2304 2.81901C11.0292 2.33782 10.5543 2 9.99992 2ZM9.19132 7.57292H10.8085L10.6744 11.888H9.32544L9.19132 7.57292ZM10.0025 13.207C10.5505 13.207 10.8788 13.5019 10.8788 14.0052C10.8788 14.4992 10.5505 14.793 10.0025 14.793C9.45052 14.793 9.11971 14.4992 9.11971 14.0052C9.11971 13.5019 9.44986 13.207 10.0025 13.207Z",
        fill: props.color ? props.color : $theme.colors.red500
    }));
};

// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/FailureCircleIcon.tsx
var FailureCircleIcon = __webpack_require__(45681);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/KebabMenuIcon.tsx
var KebabMenuIcon = __webpack_require__(38443);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/SuccessCircleIcon.tsx
var SuccessCircleIcon = __webpack_require__(41037);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/utils/index.ts
var utils = __webpack_require__(1898);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/button/PlainButton.tsx
var PlainButton = __webpack_require__(42331);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/ActionIcon.tsx
var ActionIcon = __webpack_require__(45310);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/ScheduleIcon.tsx
var ScheduleIcon = __webpack_require__(10023);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/WarningIcon.tsx
var WarningIcon = __webpack_require__(90159);
;// CONCATENATED MODULE: ../@gadgetinc/widgets/src/components/Pill.tsx















const getPillColors = (theme, error, color)=>{
    let backgroundColor;
    let textColor;
    let hoverColor;
    if (error) {
        backgroundColor = theme.colors.red50;
        textColor = theme.colors.red500;
        hoverColor = theme.colors.red600;
    } else if (isObject_default()(color)) {
        backgroundColor = color.backgroundColor;
        textColor = color.color;
        hoverColor = color.color;
    } else {
        switch(color){
            case "purple":
                {
                    backgroundColor = theme.colors.purple100;
                    textColor = theme.colors.purple400;
                    hoverColor = theme.colors.purple500;
                    break;
                }
            case "yellow":
                {
                    backgroundColor = theme.colors.yellow50;
                    textColor = theme.colors.yellow600;
                    hoverColor = theme.colors.yellow700;
                    break;
                }
            case "green":
                {
                    backgroundColor = theme.colors.green100;
                    textColor = theme.colors.green600;
                    hoverColor = theme.colors.green700;
                    break;
                }
            case "red":
                {
                    backgroundColor = theme.colors.red100;
                    textColor = theme.colors.red600;
                    hoverColor = theme.colors.red700;
                    break;
                }
            case "blue":
                {
                    backgroundColor = theme.colors.cyan50;
                    textColor = theme.colors.cyan700;
                    hoverColor = theme.colors.primary700;
                    break;
                }
            case "teal":
                {
                    backgroundColor = "#A2B9D736";
                    textColor = "#404B5A";
                    hoverColor = "#A2B9D736";
                    break;
                }
            case "light":
                {
                    backgroundColor = theme.colors.alpha100;
                    textColor = theme.colors.alpha500;
                    hoverColor = theme.colors.alpha600;
                    break;
                }
            case "alpha200":
                {
                    backgroundColor = theme.colors.alpha200;
                    textColor = theme.colors.neutralMax;
                    hoverColor = theme.colors.alpha700;
                    break;
                }
            case "production":
                {
                    backgroundColor = theme.colors.backgroundProduction;
                    textColor = "#5634AE";
                    break;
                }
            case "success":
                {
                    backgroundColor = theme.colors.green50;
                    textColor = theme.colors.green700;
                    break;
                }
            case "error":
                {
                    backgroundColor = theme.colors.red50;
                    textColor = theme.colors.red700;
                    break;
                }
            default:
            case "alpha":
                {
                    backgroundColor = theme.colors.alpha100;
                    textColor = theme.colors.alpha600;
                    hoverColor = theme.colors.alpha700;
                    break;
                }
        }
    }
    return {
        backgroundColor,
        color: textColor,
        hoverColor
    };
};
const PillContainer = (0,styled/* styled */.zo)("span", ({ $theme, $color, $error, $style })=>{
    const { backgroundColor, color } = getPillColors($theme, $error, $color);
    return {
        ...(0,utils/* paddingHorizontal */.WB)($theme.sizing.scale100),
        ...(0,utils/* paddingVertical */.i6)(0),
        display: "inline-flex",
        alignItems: "center",
        ...(0,utils/* expandBorderRadii */.uJ)("4px"),
        whiteSpace: "nowrap",
        ...$theme.typography.MonoLabelSmall,
        height: $theme.sizing.scale700,
        backgroundColor,
        color,
        ...$style
    };
});
/** A small colored span serving as a discrete label */ const Pill = (props)=>{
    const [_css, $theme] = (0,styled/* useStyletron */.hQ)();
    const { hoverColor } = getPillColors($theme, props.error, props.$color);
    return /*#__PURE__*/ react.createElement(PillContainer, {
        ...omit_default()(props, [
            "error",
            "dismissable",
            "onDismiss"
        ]),
        $error: props.error
    }, props.children, props.dismissable && /*#__PURE__*/ react.createElement(PlainButton/* PlainButton */.D, {
        onClick: props.onDismiss,
        $style: {
            display: "inline-flex",
            marginLeft: $theme.sizing.scale100,
            ":hover": {
                color: hoverColor,
                cursor: "pointer"
            }
        }
    }, /*#__PURE__*/ react.createElement(CloseIcon/* CloseIcon */.T, null)));
};
/** A pill for consistency in how we tag things that are in beta */ const BetaPill = (props)=>{
    return /*#__PURE__*/ react.createElement(Pill, {
        $style: props.$style,
        $color: "purple"
    }, props.children ?? "beta");
};
/** A pill for consistency in how we tag things that are newly released */ const NewPill = (props)=>{
    return /*#__PURE__*/ React.createElement(Pill, {
        $style: props.$style,
        $color: "green"
    }, props.children ?? "new");
};
/** A pill showing info */ const InfoPill = (props)=>{
    const [_css, $theme] = useStyletron();
    return /*#__PURE__*/ React.createElement(Pill, {
        $style: props.$style,
        $color: "blue"
    }, /*#__PURE__*/ React.createElement(InfoIcon, {
        $color: $theme.colors.blue600,
        $style: {
            marginRight: $theme.sizing.scale200
        }
    }), props.children);
};
/** A pill showing warning */ const WarningPill = (props)=>{
    const [_css, $theme] = (0,styled/* useStyletron */.hQ)();
    return /*#__PURE__*/ react.createElement(Pill, {
        $style: props.$style,
        $color: "yellow"
    }, /*#__PURE__*/ react.createElement(WarningIcon/* WarningIcon */.a, {
        color: $theme.colors.warning500
    }), props.children);
};
const SuccessPill = (props)=>{
    const [_css, $theme] = (0,styled/* useStyletron */.hQ)();
    return /*#__PURE__*/ react.createElement(Pill, {
        $style: props.$style,
        $color: "success"
    }, /*#__PURE__*/ react.createElement(SuccessCircleIcon/* SuccessCircleIcon */.B, {
        color: $theme.colors.green500,
        $style: {
            marginRight: $theme.sizing.scale200
        }
    }), props.children);
};
const FailurePill = (props)=>{
    const [_css, $theme] = (0,styled/* useStyletron */.hQ)();
    return /*#__PURE__*/ react.createElement(Pill, {
        $style: props.$style,
        $color: "error"
    }, /*#__PURE__*/ react.createElement(FailureCircleIcon/* FailureCircleIcon */.n, {
        color: $theme.colors.negative500,
        $style: {
            marginRight: $theme.sizing.scale200
        }
    }), props.children);
};
const RunningPill = (props)=>{
    const [_css, $theme] = (0,styled/* useStyletron */.hQ)();
    return /*#__PURE__*/ react.createElement(Pill, {
        $style: props.$style,
        $color: "blue"
    }, /*#__PURE__*/ react.createElement("span", {
        style: {
            marginRight: $theme.sizing.scale200,
            marginTop: $theme.sizing.scale100
        }
    }, /*#__PURE__*/ react.createElement(ActionIcon/* ActionIcon */.A, null)), props.children);
};
const PendingPill = (props)=>{
    const [_css, $theme] = (0,styled/* useStyletron */.hQ)();
    return /*#__PURE__*/ react.createElement(Pill, {
        $style: {
            color: $theme.colors.black,
            ...props.$style
        },
        $color: "alpha"
    }, /*#__PURE__*/ react.createElement(KebabMenuIcon/* default */.Z, {
        direction: "horizontal",
        $style: {
            marginRight: $theme.sizing.scale200,
            color: $theme.colors.black
        }
    }), props.children);
};
const RetryingPill = (props)=>{
    const [_css, $theme] = (0,styled/* useStyletron */.hQ)();
    return /*#__PURE__*/ react.createElement(Pill, {
        $style: {
            ...props.$style
        },
        $color: "yellow"
    }, /*#__PURE__*/ react.createElement(ErrorInfoIcon, {
        color: $theme.colors.yellow500,
        $style: {
            marginRight: $theme.sizing.scale200
        }
    }), props.children);
};
const ScheduledPill = (props)=>{
    const [_css, $theme] = (0,styled/* useStyletron */.hQ)();
    return /*#__PURE__*/ react.createElement(Pill, {
        $style: {
            color: $theme.colors.black,
            ...props.$style
        },
        $color: "alpha"
    }, /*#__PURE__*/ react.createElement(ScheduleIcon/* ScheduleIcon */._, {
        $style: {
            color: $theme.colors.black,
            marginRight: $theme.sizing.scale200,
            width: $theme.sizing.scale550,
            height: $theme.sizing.scale550
        }
    }), props.children);
};


/***/ }),

/***/ 73830:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   L: () => (/* binding */ Spacer),
/* harmony export */   X: () => (/* binding */ Row)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10334);

const Row = (0,baseui__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", (props)=>({
        display: "flex",
        flexDirection: "row",
        justifyContent: props.$align,
        alignItems: "center",
        gap: props.$gap
    }));
const Spacer = (0,baseui__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", {
    flexGrow: 1
});


/***/ }),

/***/ 29919:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Lv: () => (/* binding */ ButtonKind),
/* harmony export */   aH: () => (/* binding */ ButtonHoverSelector),
/* harmony export */   zx: () => (/* binding */ Button)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10334);
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72221);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1898);
/* harmony import */ var baseui_button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67710);
/* harmony import */ var baseui_button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19895);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88469);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73352);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30242);
/* harmony import */ var _utils_KeyNormalizedControl__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(44122);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85728);


// eslint-disable-next-line no-restricted-imports






// eslint-disable-next-line no-restricted-imports

const ButtonHoverSelector = ":hover:not(:disabled):not(:active)";
/**
 * BaseUI reexport for minimal buttons because we need to pass overrides to style the text right. Wherever you want to use a <Button />, you should use this instead.
 * See https://github.com/uber/baseweb/issues/106 for more information
 */ const ButtonKind = {
    primary: "primary",
    secondary: "secondary",
    tertiary: "tertiary",
    minimal: "minimal",
    danger: "danger",
    delete: "delete",
    tertiaryDestructive: "tertiaryDestructive"
};
const Button = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)((props, ref)=>{
    const [_css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_3__/* .useStyletron */ .hQ)();
    const rawProps = {};
    const { disableButtons } = (0,_contexts__WEBPACK_IMPORTED_MODULE_4__/* .useWidgets */ .e)();
    const disabled = props.disabled ?? disableButtons?.(props);
    const kind = props.kind ?? "primary";
    const rawSize = props.size == "tight" ? baseui_button__WEBPACK_IMPORTED_MODULE_5__/* .SIZE */ .NO.compact : props.size == "square" ? baseui_button__WEBPACK_IMPORTED_MODULE_5__/* .SIZE */ .NO.default : props.size;
    let overrides = {
        BaseButton: {
            style: {
                cursor: disabled ? "not-allowed !important" : "pointer",
                transitionProperty: "background, background-color",
                transitionDuration: "0s",
                ":focus-visible": {
                    outline: `2px solid ${$theme.colors.borderFocus}`,
                    outlineOffset: "1px"
                },
                userSelect: "none"
            }
        },
        StartEnhancer: {
            style: {
                marginRight: $theme.sizing.scale300
            }
        },
        EndEnhancer: {
            style: {
                marginLeft: $theme.sizing.scale300
            }
        }
    };
    switch(props.size){
        case "tight":
            {
                lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(overrides, {
                    BaseButton: {
                        style: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .paddingUtil */ .N1)($theme.sizing.scale0)
                    }
                });
                break;
            }
        case baseui_button__WEBPACK_IMPORTED_MODULE_5__/* .SIZE */ .NO.large:
            {
                lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(overrides, {
                    BaseButton: {
                        style: {
                            ...(0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .paddingVertical */ .i6)($theme.sizing.scale300),
                            ...$theme.typography.body
                        }
                    }
                });
                break;
            }
        case undefined:
        case baseui_button__WEBPACK_IMPORTED_MODULE_5__/* .SIZE */ .NO.compact:
        case baseui_button__WEBPACK_IMPORTED_MODULE_5__/* .SIZE */ .NO.default:
            {
                lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(overrides, {
                    BaseButton: {
                        style: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .paddingUtil */ .N1)($theme.sizing.scale200, $theme.sizing.scale500)
                    },
                    StartEnhancer: {
                        style: {
                            marginRight: $theme.sizing.scale400
                        }
                    }
                });
            }
    }
    const activeStyle = {
        backgroundColor: "transparent",
        boxShadow: "none",
        textDecoration: "underline"
    };
    const style = {
        primary: {
            backgroundColor: $theme.colors.primary700,
            boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .borderShadow */ .ic)($theme.colors.neutralMax, 1, $theme.lighting.shadowButtonPrimary),
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .expandBorderWidth */ .wW)(0),
            ":active:not(:disabled)": {
                boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .borderShadow */ .ic)($theme.colors.neutralMax, 0, $theme.lighting.shadowButtonPrimaryInset)
            },
            ":active:not(:disabled) > *": {
                transform: "translateY(1px)"
            },
            ":disabled": {
                backgroundColor: $theme.colors.alpha300,
                color: $theme.colors.primary50,
                boxShadow: "none"
            }
        },
        secondary: {
            color: $theme.colors.black,
            boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .borderShadow */ .ic)($theme.colors.primary300, 1, $theme.lighting.shadowButton),
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .expandBorderWidth */ .wW)(0),
            backgroundColor: $theme.colors.neutralMin,
            ":active:not(:disabled)": {
                boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .borderShadow */ .ic)($theme.colors.primary300, 1, $theme.lighting.shadowButtonInset),
                backgroundColor: $theme.colors.primary50
            },
            ":active:not(:disabled) > *": {
                transform: "translateY(1px)"
            },
            ":disabled": {
                backgroundColor: $theme.colors.alpha50,
                boxShadow: "none"
            }
        },
        tertiary: {
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .paddingUtil */ .N1)("0px"),
            color: props.size == baseui_button__WEBPACK_IMPORTED_MODULE_5__/* .SIZE */ .NO.compact ? $theme.colors.linkText : $theme.colors.contentLinkText,
            textDecoration: $theme.typography.contentLink?.textDecoration ?? "none",
            backgroundColor: "transparent",
            textUnderlineOffset: "3px",
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .expandBorderWidth */ .wW)(0),
            ":hover:not(:disabled)": {
                ...activeStyle
            },
            ":hover:not(:disabled):not(:active)": {
                ...activeStyle,
                color: props.size == baseui_button__WEBPACK_IMPORTED_MODULE_5__/* .SIZE */ .NO.compact ? $theme.colors.linkHover : $theme.colors.contentLinkHover
            },
            ":focus-visible": {
                ...activeStyle,
                color: props.size == baseui_button__WEBPACK_IMPORTED_MODULE_5__/* .SIZE */ .NO.compact ? $theme.colors.linkHover : $theme.colors.contentLinkHover,
                outlineOffset: "3px"
            },
            ":disabled": {
                color: $theme.colors.alpha400,
                backgroundColor: "transparent"
            },
            ":active:not(:disabled)": {
                ...activeStyle,
                color: props.size == baseui_button__WEBPACK_IMPORTED_MODULE_5__/* .SIZE */ .NO.compact ? $theme.colors.linkActive : $theme.colors.contentLinkActive,
                transform: "perspective(500px) translate3d(0, 0, -20px)"
            }
        },
        danger: {
            backgroundColor: $theme.colors.red500,
            boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .borderShadow */ .ic)($theme.colors.red600, 1, $theme.lighting.shadowButtonPrimary),
            ":hover:not(:disabled):not(:active)": {
                backgroundColor: $theme.colors.red400,
                boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .borderShadow */ .ic)($theme.colors.red500, 1, $theme.lighting.shadowButtonPrimary)
            },
            ":active:not(:disabled)": {
                backgroundColor: $theme.colors.red400,
                boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .borderShadow */ .ic)($theme.colors.red400, 1, $theme.lighting.shadowButtonPrimaryInset)
            },
            ":active:not(:disabled) > *": {
                transform: "translateY(1px)"
            },
            ":disabled": {
                boxShadow: "none",
                border: `1px solid ${$theme.colors.primary100}`
            }
        },
        delete: {
            color: $theme.colors.red500,
            backgroundColor: $theme.colors.neutralMin,
            boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .borderShadow */ .ic)($theme.colors.red200, 1, $theme.lighting.shadowButton),
            ":hover:not(:disabled):not(:active)": {
                backgroundColor: $theme.colors.red50,
                boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .borderShadow */ .ic)($theme.colors.red300, 1, $theme.lighting.shadowButton)
            },
            ":active:not(:disabled)": {
                backgroundColor: $theme.colors.red50,
                boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .borderShadow */ .ic)($theme.colors.red400, 1, $theme.lighting.shadowButtonInset)
            },
            ":active:not(:disabled) > *": {
                transform: "translateY(1px)"
            },
            ":disabled": {
                boxShadow: "none",
                color: $theme.colors.primary50,
                backgroundColor: $theme.colors.primary300,
                border: `1px solid ${$theme.colors.primary300}`
            }
        },
        tertiaryDestructive: {
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .paddingUtil */ .N1)("0px"),
            color: $theme.colors.red500,
            backgroundColor: "transparent",
            ":hover:not(:disabled)": {
                backgroundColor: "transparent",
                boxShadow: "none"
            },
            ":hover:not(:disabled):not(:active)": {
                backgroundColor: "transparent",
                boxShadow: "none",
                color: $theme.colors.red600
            },
            ":focus-visible": {
                backgroundColor: "transparent",
                boxShadow: "none",
                color: $theme.colors.red600,
                outlineOffset: "3px"
            },
            ":active:not(:disabled)": {
                backgroundColor: "transparent",
                color: $theme.colors.red700,
                transform: "perspective(500px) translate3d(0, 0, -20px)"
            }
        }
    };
    lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(overrides, {
        BaseButton: {
            style: style[kind]
        }
    });
    if (props.$pressed) {
        const style = overrides.BaseButton?.style;
        if (style?.[":active:not(:disabled)"]) {
            lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(style, style[":active:not(:disabled)"]);
        }
    }
    overrides = (0,baseui__WEBPACK_IMPORTED_MODULE_7__/* .mergeOverrides */ .aO)(overrides, props.overrides);
    // normalizeKeys is not a valid prop for Button
    lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(rawProps, lodash_omit__WEBPACK_IMPORTED_MODULE_1___default()(props, [
        "children",
        "normalizeKeys"
    ]));
    if (props.$style) {
        lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(overrides.BaseButton.style, props.$style);
    }
    // wrap any child that is a raw string in a wrapper span, so that the CSS selectors which translate the children on active can target them. children that are already an element and not a string aren't wrapped to keep things as unchanged as possible
    // eslint-disable-next-line react/jsx-key
    const children = react__WEBPACK_IMPORTED_MODULE_2__.Children.map(props.children, (child)=>{
        return typeof child === "string" ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", {
            style: {
                whiteSpace: overrides.BaseButton?.style?.whiteSpace ?? "pre-wrap"
            }
        }, child) : child;
    });
    const basewebKind = kind == "delete" ? "secondary" : kind == "danger" ? "primary" : kind == "tertiaryDestructive" ? "tertiary" : kind;
    const button = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(baseui_button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        ref: ref,
        ...rawProps,
        disabled: disabled,
        overrides: overrides,
        kind: basewebKind,
        size: rawSize,
        draggable: props.draggable ? true : false
    }, children);
    return props.normalizeKeys ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_utils_KeyNormalizedControl__WEBPACK_IMPORTED_MODULE_9__/* .KeyNormalizedControl */ .w, {
        mode: "simple",
        ignoreKeyProps: {
            style: {
                lineHeight: "0"
            }
        }
    }, button) : button;
});


/***/ }),

/***/ 42331:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   D: () => (/* binding */ PlainButton)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10334);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88469);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1898);



/**
 * A plain button component that doesn't apply any styling to the contents
 *
 * Useful for making clickable elements inside other things. Try to use this instead of a `div` or `Row` with an `onClick` :)
 */ const PlainButton = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("button", ({ $theme, $row, $selected, $style })=>{
    return lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({
        fontFamily: "inherit",
        lineHeight: "inherit",
        fontWeight: "inherit",
        fontSize: "inherit",
        textDecoration: "underline",
        display: $row ? "flex" : "initial",
        alignItems: "center",
        ...(0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .expandPadding */ .ft)(0),
        ...(0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .expandMargin */ .ds)(0),
        ...(0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .expandBorderWidth */ .wW)("0px"),
        backgroundColor: $selected ? $theme.colors.primary200 : "unset",
        width: "min-content",
        whiteSpace: "nowrap",
        textUnderlinePosition: "under",
        color: "unset",
        ":hover": {
            backgroundColor: $selected ? $theme.colors.primary200 : "unset",
            color: $theme.colors.contentTertiary,
            cursor: "pointer"
        },
        ":active": {
            backgroundColor: $selected ? $theme.colors.primary200 : "unset"
        },
        ":focus-visible": {
            outline: `auto 1px ${$theme.colors.borderFocus}`
        }
    }, $style);
});


/***/ }),

/***/ 85728:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   W: () => (/* binding */ WidgetsContext),
/* harmony export */   e: () => (/* binding */ useWidgets)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);

const WidgetsContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
const useWidgets = ()=>{
    const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(WidgetsContext);
    return context ?? {};
};


/***/ }),

/***/ 45310:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ ActionIcon)
/* harmony export */ });
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74995);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);


const ActionIcon = (props)=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_1__/* .Svg */ .n, {
        viewBox: "0 0 30 30",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M17.0001 2.00002C16.8205 2.00022 16.6444 2.04874 16.4901 2.1405C16.3358 2.23226 16.209 2.36386 16.1231 2.5215L8.17388 15.4336V15.4356C8.06043 15.6019 7.99984 15.7987 8.00005 16C8.00005 16.2652 8.10541 16.5196 8.29294 16.7071C8.48048 16.8947 8.73483 17 9.00005 17H14.5L13.0196 26.8008C13.0064 26.8664 12.9999 26.9331 13 27C13 27.2652 13.1054 27.5196 13.2929 27.7071C13.4805 27.8947 13.7348 28 14 28C14.1818 27.9997 14.36 27.9499 14.5155 27.856C14.671 27.7621 14.798 27.6275 14.8829 27.4668H14.8848L22.8067 14.5899L22.7969 14.5723C22.9153 14.408 23 14.2178 23 14C23 13.448 22.552 13 22 13H16.5001L17.9551 3.29494C17.9848 3.19943 17.9999 3.10002 18 3.00002C18 2.7348 17.8947 2.48044 17.7072 2.29291C17.5196 2.10537 17.2653 2.00002 17.0001 2.00002V2.00002Z"
    }));


/***/ }),

/***/ 33619:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   T: () => (/* binding */ CloseIcon)
/* harmony export */ });
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74995);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);


const CloseIcon = (props)=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_1__/* .Svg */ .n, {
        viewBox: "0 0 16 16",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.14478 3.17316C2.18007 3.34135 2.26456 3.49524 2.3875 3.61529L6.77382 8.00162L2.38794 12.3875C2.3055 12.4671 2.23964 12.5622 2.19418 12.6673C2.14843 12.7732 2.12426 12.8871 2.12309 13.0024C2.12192 13.1177 2.14376 13.2321 2.18735 13.3388C2.23093 13.4456 2.29537 13.5426 2.37691 13.6241C2.45844 13.7056 2.55542 13.7701 2.66217 13.8136C2.76893 13.8572 2.8833 13.8791 2.9986 13.8779C3.1139 13.8767 3.22781 13.8526 3.33365 13.8068C3.43883 13.7614 3.53395 13.6955 3.6135 13.613L7.99937 9.22717L12.3853 13.613C12.4648 13.6955 12.5599 13.7614 12.6651 13.8068C12.7709 13.8526 12.8848 13.8767 13.0001 13.8779C13.1155 13.8791 13.2298 13.8572 13.3366 13.8136C13.4433 13.7701 13.5403 13.7056 13.6218 13.6241C13.7034 13.5426 13.7678 13.4456 13.8114 13.3388C13.855 13.2321 13.8768 13.1177 13.8757 13.0024C13.8745 12.8871 13.8503 12.7732 13.8046 12.6673C13.7591 12.5622 13.6932 12.4671 13.6108 12.3875L9.22492 8.00162L13.6108 3.61576C13.736 3.49505 13.822 3.33945 13.8576 3.16917C13.8934 2.99815 13.8767 2.82032 13.8096 2.65899C13.7425 2.49766 13.6282 2.36037 13.4818 2.26512C13.3353 2.16987 13.1635 2.12111 12.9888 2.12524C12.7605 2.13063 12.5436 2.22588 12.3852 2.39025L7.99937 6.77607L3.61306 2.38975C3.5324 2.30713 3.43605 2.24144 3.32965 2.19657C3.2228 2.1515 3.10793 2.12834 2.99196 2.12844C2.81963 2.12866 2.65127 2.18024 2.5084 2.2766C2.36553 2.37296 2.25462 2.50972 2.18985 2.66942C2.12508 2.82912 2.10939 3.0045 2.14478 3.17316Z"
    }));


/***/ }),

/***/ 45681:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   n: () => (/* binding */ FailureCircleIcon)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10334);
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74995);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);



const FailureCircleIcon = (props)=>{
    const [_css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .hQ)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_2__/* .Svg */ .n, {
        viewBox: "0 0 16 16",
        ...props,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M8.00001 1.60001C4.46561 1.60001 1.60001 4.46561 1.60001 8.00001C1.60001 11.5344 4.46561 14.4 8.00001 14.4C11.5344 14.4 14.4 11.5344 14.4 8.00001C14.4 4.46561 11.5344 1.60001 8.00001 1.60001ZM10.5104 9.75627C10.7189 9.96481 10.7189 10.3019 10.5104 10.5104C10.4064 10.6144 10.2699 10.6667 10.1333 10.6667C9.99681 10.6667 9.86027 10.6144 9.75627 10.5104L8.00001 8.75414L6.24374 10.5104C6.13974 10.6144 6.00321 10.6667 5.86667 10.6667C5.73014 10.6667 5.59361 10.6144 5.48961 10.5104C5.28107 10.3019 5.28107 9.96481 5.48961 9.75627L7.24587 8.00001L5.48961 6.24374C5.28107 6.03521 5.28107 5.69814 5.48961 5.48961C5.69814 5.28107 6.03521 5.28107 6.24374 5.48961L8.00001 7.24587L9.75627 5.48961C9.96481 5.28107 10.3019 5.28107 10.5104 5.48961C10.7189 5.69814 10.7189 6.03521 10.5104 6.24374L8.75414 8.00001L10.5104 9.75627Z",
        fill: props.color ?? (props.$disabled ? $theme.colors.contentStateDisabled : $theme.colors.red500)
    }));
};


/***/ }),

/***/ 38443:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74995);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);


const KebabMenuIcon = (props)=>{
    const rotation = props.direction === "horizontal" ? 0 : 90;
    const viewBox = props.direction === "horizontal" ? "0 0 16 16" : "0 0 8 16";
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_1__/* .Svg */ .n, {
        viewBox: viewBox,
        ...props,
        fill: "none"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M2.6 6.40039C1.7164 6.40039 1 7.11679 1 8.00039C1 8.88399 1.7164 9.60039 2.6 9.60039C3.4836 9.60039 4.2 8.88399 4.2 8.00039C4.2 7.11679 3.4836 6.40039 2.6 6.40039ZM8 6.40039C7.1164 6.40039 6.4 7.11679 6.4 8.00039C6.4 8.88399 7.1164 9.60039 8 9.60039C8.8836 9.60039 9.6 8.88399 9.6 8.00039C9.6 7.11679 8.8836 6.40039 8 6.40039ZM13.4 6.40039C12.5164 6.40039 11.8 7.11679 11.8 8.00039C11.8 8.88399 12.5164 9.60039 13.4 9.60039C14.2836 9.60039 15 8.88399 15 8.00039C15 7.11679 14.2836 6.40039 13.4 6.40039Z",
        transform: `rotate(${rotation} 6 6)`
    }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (KebabMenuIcon);


/***/ }),

/***/ 10023:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   _: () => (/* binding */ ScheduleIcon)
/* harmony export */ });
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74995);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);


const ScheduleIcon = (props)=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_1__/* .Svg */ .n, {
        viewBox: "0 0 14 14",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M6.46664 0.599976V3.26664C6.46564 3.33732 6.4787 3.40748 6.50505 3.47307C6.53141 3.53865 6.57053 3.59834 6.62016 3.64867C6.66978 3.699 6.72891 3.73897 6.79412 3.76625C6.85932 3.79352 6.9293 3.80757 6.99998 3.80757C7.07066 3.80757 7.14063 3.79352 7.20584 3.76625C7.27104 3.73897 7.33017 3.699 7.37979 3.64867C7.42942 3.59834 7.46854 3.53865 7.4949 3.47307C7.52125 3.40748 7.53431 3.33732 7.53331 3.26664V1.77393C10.2202 2.05294 12.3333 4.2376 12.3333 6.99998C12.3333 9.95173 9.95173 12.3333 6.99998 12.3333C4.04822 12.3333 1.66664 9.95173 1.66664 6.99998C1.66664 5.69133 2.137 4.50011 2.91768 3.57289C2.96283 3.51927 2.99697 3.45728 3.01816 3.39046C3.03935 3.32364 3.04717 3.25331 3.04118 3.18347C3.03518 3.11363 3.01549 3.04565 2.98322 2.98342C2.95096 2.92119 2.90675 2.86593 2.85312 2.82078C2.7995 2.77564 2.7375 2.7415 2.67069 2.72032C2.60387 2.69913 2.53353 2.69132 2.46369 2.69731C2.39385 2.70331 2.32587 2.72301 2.26365 2.75528C2.20142 2.78755 2.14616 2.83176 2.10102 2.88539C1.16544 3.99658 0.599976 5.43502 0.599976 6.99998C0.599976 10.5282 3.47173 13.4 6.99998 13.4C10.5282 13.4 13.4 10.5282 13.4 6.99998C13.4 3.47173 10.5282 0.599976 6.99998 0.599976H6.46664ZM4.01039 3.80414C3.85422 3.82692 3.73764 4.01009 3.84164 4.17289C4.62244 5.39796 5.95568 7.46401 6.24581 7.75414C6.66234 8.17068 7.33761 8.17068 7.75414 7.75414C8.17068 7.33761 8.17068 6.66234 7.75414 6.24581C7.46401 5.95514 5.39796 4.62244 4.17289 3.84164C4.11863 3.80698 4.06245 3.79655 4.01039 3.80414Z"
    }));


/***/ }),

/***/ 41037:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   B: () => (/* binding */ SuccessCircleIcon)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10334);
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74995);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);



const SuccessCircleIcon = (props)=>{
    const [_css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .hQ)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_2__/* .Svg */ .n, {
        viewBox: "0 0 16 16",
        ...props,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.00001 14.4C11.5346 14.4 14.4 11.5346 14.4 8.00001C14.4 4.46538 11.5346 1.60001 8.00001 1.60001C4.46538 1.60001 1.60001 4.46538 1.60001 8.00001C1.60001 11.5346 4.46538 14.4 8.00001 14.4ZM7.28262 10.5032L11.3104 6.28575C11.5188 6.06763 11.5188 5.71506 11.3104 5.49693C11.1021 5.27881 10.7654 5.27881 10.5571 5.49693L6.90594 9.31999L5.44293 7.78809C5.23461 7.56996 4.89789 7.56996 4.68958 7.78809C4.48126 8.00621 4.48126 8.35878 4.68958 8.57691L6.52927 10.5032C6.6289 10.6081 6.76476 10.6667 6.90594 10.6667C7.04713 10.6667 7.18246 10.6081 7.28262 10.5032Z",
        fill: props.color ?? (props.$disabled ? $theme.colors.contentStateDisabled : $theme.colors.green600)
    }));
};


/***/ }),

/***/ 90159:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   a: () => (/* binding */ WarningIcon)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10334);
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74995);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);



const WarningIcon = (props)=>{
    const [_css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .hQ)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_2__/* .Svg */ .n, {
        viewBox: "0 0 16 16",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
        x: "7",
        y: "5",
        width: "2",
        height: "8",
        fill: "transparent"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M7.99998 1.59998C7.55648 1.59998 7.17655 1.87023 7.01561 2.25518L1.22707 12.2385V12.2396C1.1226 12.4078 1.06705 12.6019 1.06665 12.8C1.06665 13.0829 1.17903 13.3542 1.37907 13.5542C1.57911 13.7543 1.85042 13.8666 2.13332 13.8666C2.15835 13.8665 2.18336 13.8654 2.20832 13.8635L2.2104 13.8666H7.99998H13.7896L13.7917 13.8625C13.8166 13.8647 13.8416 13.8661 13.8667 13.8666C14.1495 13.8666 14.4209 13.7543 14.6209 13.5542C14.8209 13.3542 14.9333 13.0829 14.9333 12.8C14.9331 12.6015 14.8776 12.4071 14.7729 12.2385L14.7646 12.2239C14.7642 12.2236 14.7639 12.2232 14.7635 12.2229L8.98436 2.25518C8.82342 1.87023 8.44349 1.59998 7.99998 1.59998ZM7.35311 6.05831H8.64686L8.53957 9.51039H7.4604L7.35311 6.05831ZM8.00207 10.5656C8.44047 10.5656 8.70311 10.8015 8.70311 11.2041C8.70311 11.5993 8.44047 11.8343 8.00207 11.8343C7.56047 11.8343 7.29582 11.5993 7.29582 11.2041C7.29582 10.8015 7.55993 10.5656 8.00207 10.5656Z",
        fill: props.color ?? (props.$disabled ? $theme.colors.contentStateDisabled : $theme.colors.yellow500)
    }));
};


/***/ }),

/***/ 75580:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Dh: () => (/* binding */ space),
/* harmony export */   Ql: () => (/* binding */ gadgetColorsDark),
/* harmony export */   Ro: () => (/* binding */ gadgetShadows),
/* harmony export */   d_: () => (/* binding */ gadgetColorsLight),
/* harmony export */   pD: () => (/* binding */ radii),
/* harmony export */   uQ: () => (/* binding */ productTypography),
/* harmony export */   zG: () => (/* binding */ getPrimitiveColors)
/* harmony export */ });
const gadgetColorsLight = {
    neutralMin: "#FFF",
    neutralMax: "#000",
    primary50: "#F6F6F6",
    primary100: "#EEEEEE",
    primary200: "#E2E2E2",
    primary300: "#CBCBCB",
    primary400: "#AFAFAF",
    primary500: "#757575",
    primary600: "#545454",
    primary700: "#333333",
    alpha0: "rgba(0, 0, 0, 0)",
    alpha50: "rgba(0, 0, 0, 0.03)",
    alpha100: "rgba(0, 0, 0, 0.07)",
    alpha200: "rgba(0, 0, 0, 0.11)",
    alpha300: "rgba(0, 0, 0, 0.2)",
    alpha400: "rgba(0, 0, 0, 0.31)",
    alpha500: "rgba(0, 0, 0, 0.54)",
    alpha600: "rgba(0, 0, 0, 0.67)",
    alpha700: "rgba(0, 0, 0, 0.8)",
    alpha800: "rgba(0, 0, 0, 0.9)",
    alpha900: "rgba(0, 0, 0, 0.95)",
    electricBlue50: "#ECECFF",
    electricBlue100: "#D9D9FE",
    electricBlue200: "#B3B3FE",
    electricBlue300: "#8E8EFD",
    electricBlue400: "#6868FD",
    electricBlue500: "#4242FC",
    electricBlue600: "#3535CE",
    electricBlue700: "#2828A0",
    yellow50: "#FFF8EC",
    yellow100: "#FDEDD6",
    yellow200: "#FBE6BC",
    yellow300: "#FACF8F",
    yellow400: "#FCBC63",
    yellow500: "#DC892A",
    yellow600: "#A66822",
    yellow700: "#6F4616",
    red50: "#FFEDEB",
    red100: "#FFDBD7",
    red200: "#F7AEA6",
    red300: "#F27769",
    red400: "#DB3927",
    red500: "#B13325",
    red600: "#8C2B20",
    red700: "#6D1F17",
    green50: "#F0F9F4",
    green100: "#DAF0E3",
    green200: "#AEDDC2",
    green300: "#73C496",
    green400: "#3AA76D",
    green500: "#368759",
    green600: "#2B6B46",
    green700: "#1C472F",
    blue50: "#F0F3FD",
    blue100: "#D7E2FA",
    blue200: "#A6BEF3",
    blue300: "#6790EE",
    blue400: "#3B6CE9",
    blue500: "#2D53B1",
    blue600: "#23418C",
    blue700: "#172B5D",
    cyan50: "#EFF8FF",
    cyan100: "#D2EFFF",
    cyan200: "#B6E5FF",
    cyan300: "#92D7FE",
    cyan400: "#63C7FF",
    cyan500: "#3A9BD1",
    cyan600: "#3383AF",
    cyan700: "#1B5B80",
    purple50: "#F7F5FD",
    purple100: "#F1EBFF",
    purple200: "#DBCBFF",
    purple300: "#BEA1FF",
    purple400: "#9E72FE",
    purple500: "#6F4BCD",
    purple600: "#5B38B6",
    purple700: "#3B227A",
    purpleAlpha50: "rgba(62, 14, 169, 0.04)",
    purpleAlpha100: "#4F00FF14",
    purpleAlpha200: "#5407FE36",
    purpleAlpha300: "#5407FE61",
    purpleAlpha400: "#5407FE91",
    purpleAlpha500: "#4208C2BF",
    purpleAlpha600: "#3500ABCC",
    purpleAlpha700: "#210066DE",
    gellyPurple: "#9B50D7",
    development: "#404B5A",
    disabledDevelopment: "#404B5AB2",
    backgroundDevelopment: "rgba(162, 185, 215, 0.21)",
    inputAlpha: "rgba(0, 0, 0, 0.01)",
    splashIllustrationBackground: "#F8F8FE",
    backgroundEnvironmentSettingsCalloutDevelopment: "#EBF0F6",
    contentEnvironmentSettingsCalloutDevelopment: "rgba(64, 75, 90, 0.60)",
    backgroundEnvironmentSettingsCalloutProduction: "#F2EDFD",
    contentEnvironmentSettingsCalloutProduction: "#5634AE99"
};
const gadgetColorsDark = {
    neutralMin: "#000",
    neutralMax: "#FFF",
    primary50: "#333333",
    primary100: "#545454",
    primary200: "#757575",
    primary300: "#AFAFAF",
    primary400: "#CBCBCB",
    primary500: "#E2E2E2",
    primary600: "#EEEEEE",
    primary700: "#F6F6F6",
    alpha0: "rgba(255, 255, 255, 0)",
    alpha50: "rgba(255, 255, 255, 0.03)",
    alpha100: "rgba(255, 255, 255, 0.07)",
    alpha200: "rgba(255, 255, 255, 0.11)",
    alpha300: "rgba(255, 255, 255, 0.2)",
    alpha400: "rgba(255, 255, 255, 0.31)",
    alpha500: "rgba(255, 255, 255, 0.54)",
    alpha600: "rgba(255, 255, 255, 0.67)",
    alpha700: "rgba(255, 255, 255, 0.8)",
    alpha800: "rgba(255, 255, 255, 0.9)",
    alpha900: "rgba(255, 255, 255, 0.95)",
    electricBlue50: "#2828A0",
    electricBlue100: "#3535CE",
    electricBlue200: "#4242FC",
    electricBlue300: "#6868FD",
    electricBlue400: "#8E8EFD",
    electricBlue500: "#B3B3FE",
    electricBlue600: "#D9D9FE",
    electricBlue700: "#ECECFF",
    yellow50: "#6F4616",
    yellow100: "#A66822",
    yellow200: "#DC892A",
    yellow300: "#FCBC63",
    yellow400: "#FACF8F",
    yellow500: "#FBE6BC",
    yellow600: "#FDEDD6",
    yellow700: "#FFF8EC",
    red50: "#6D1F17",
    red100: "#8C2B20",
    red200: "#B13325",
    red300: "#DB3927",
    red400: "#F27769",
    red500: "#F7AEA6",
    red600: "#FFDBD7",
    red700: "#FFEDEB",
    green50: "#1C472F",
    green100: "#2B6B46",
    green200: "#368759",
    green300: "#3AA76D",
    green400: "#73C496",
    green500: "#AEDDC2",
    green600: "#DAF0E3",
    green700: "#F0F9F4",
    blue50: "#172B5D",
    blue100: "#23418C",
    blue200: "#2D53B1",
    blue300: "#3B6CE9",
    blue400: "#6790EE",
    blue500: "#A6BEF3",
    blue600: "#D7E2FA",
    blue700: "#F0F3FD",
    cyan50: "#1B5B80",
    cyan100: "#3383AF",
    cyan200: "#3A9BD1",
    cyan300: "#63C7FF",
    cyan400: "#92D7FE",
    cyan500: "#B6E5FF",
    cyan600: "#D2EFFF",
    cyan700: "#EFF8FF",
    purple50: "#261650",
    purple100: "#361D77",
    purple200: "#5D39BB",
    purple300: "#7340E4",
    purple400: "#9168EC",
    purple500: "#BFA8F2",
    purple600: "#E3D7FD",
    purple700: "#F5F2FC",
    purpleAlpha50: "#210066DE",
    purpleAlpha100: "#3500ABCC",
    purpleAlpha200: "#4208C2BF",
    purpleAlpha300: "#5407FE91",
    purpleAlpha400: "#5407FE61",
    purpleAlpha500: "#5407FE36",
    purpleAlpha600: "#4F00FF14",
    purpleAlpha700: "rgba(62, 14, 169, 0.04)",
    gellyPurple: "#8d3ccf",
    development: "#404B5A",
    disabledDevelopment: "#404B5AB2",
    backgroundDevelopment: "rgba(162, 185, 215, 0.21)",
    inputAlpha: "rgba(0, 0, 0, 0.01)",
    splashIllustrationBackground: "#F8F8FE",
    backgroundEnvironmentSettingsCalloutDevelopment: "#EBF0F6",
    contentEnvironmentSettingsCalloutDevelopment: "rgba(64, 75, 90, 0.60)",
    backgroundEnvironmentSettingsCalloutProduction: "#F2EDFD",
    contentEnvironmentSettingsCalloutProduction: "#5634AE99"
};
const gadgetShadows = {
    selected: "0px 2px 0px 1px rgb(66, 66, 252, 0.3)",
    depth2: "0px 3px 2px -1px rgba(0, 0, 0, 0.12)",
    depth3: "0px 8px 16px -4px rgba(0, 0, 0, 0.24)",
    depth4: "0px 12px 20px -8px rgba(0, 0, 0, 0.32)",
    shadowButton: "0px -1px 0px 0px rgba(0, 0, 0, 0.24) inset, 0px 1px 1px 0px rgba(0, 0, 0, 0.16)",
    shadowButtonPrimary: "0px -2px 0px 0px rgba(0, 0, 0, 0.24) inset, 0px 1px 1px 0px rgba(0, 0, 0, 0.16)",
    shadowButtonInset: "0px 2px 2px 0px rgba(0, 0, 0, 0.16) inset, 1px 0px 1px 0px rgba(0, 0, 0, 0.08) inset, -1px 0px 1px 0px rgba(0, 0, 0, 0.08) inset",
    shadowButtonPrimaryInset: "0px 2px 2px 0px rgba(0, 0, 0, 0.32) inset, 1px 0px 1px 0px rgba(0, 0, 0, 0.16) inset, -1px 0px 1px 0px rgba(0, 0, 0, 0.16) inset",
    shadowInputInset: "0px 1px 1px 0px rgba(0, 0, 0, 0.08) inset"
};
const productTypography = {
    title: {
        fontFamily: "Inconsolata",
        fontSize: "20px",
        fontWeight: 600,
        lineHeight: "30px",
        letterSpacing: "0px",
        textAlign: "left"
    },
    navTitle: {
        fontFamily: "Inconsolata",
        fontSize: "12px",
        fontWeight: 500,
        lineHeight: "16px",
        letterSpacing: "1px",
        textAlign: "left"
    },
    heading: {
        fontFamily: "Inconsolata",
        fontSize: "16px",
        fontWeight: 700,
        lineHeight: "22px",
        letterSpacing: "0px",
        textAlign: "left"
    },
    subHeading: {
        fontFamily: "Inconsolata",
        fontSize: "14px",
        fontWeight: 700,
        lineHeight: "20px",
        letterSpacing: "0px",
        textAlign: "left"
    },
    body: {
        fontFamily: "Inconsolata",
        fontSize: "14px",
        fontWeight: 500,
        lineHeight: "20px",
        letterSpacing: "0px",
        textAlign: "left"
    },
    caption: {
        fontFamily: "Inconsolata",
        fontSize: "12px",
        fontWeight: 500,
        lineHeight: "16px",
        letterSpacing: "0px",
        textAlign: "left"
    },
    contentLink: {
        textDecoration: "none"
    }
};
const getPrimitiveColors = (palette)=>({
        accent: palette.electricBlue500,
        accent50: palette.purple50,
        accent100: palette.purple100,
        accent200: palette.purple200,
        accent300: palette.purple300,
        accent400: palette.purple400,
        accent500: palette.purple500,
        accent600: palette.purple600,
        accent700: palette.purple700,
        negative50: palette.red50,
        negative100: palette.red100,
        negative200: palette.red200,
        negative300: palette.red300,
        negative400: palette.red400,
        negative500: palette.red500,
        negative600: palette.red600,
        negative700: palette.red700,
        warning50: palette.yellow50,
        warning100: palette.yellow100,
        warning200: palette.yellow200,
        warning300: palette.yellow300,
        warning400: palette.yellow400,
        warning500: palette.yellow500,
        warning600: palette.yellow600,
        warning700: palette.yellow700,
        positive50: palette.green50,
        positive100: palette.green100,
        positive200: palette.green200,
        positive300: palette.green300,
        positive400: palette.green400,
        positive500: palette.green500,
        positive600: palette.green600,
        positive700: palette.green700,
        primary50: palette.primary50,
        primary100: palette.primary100,
        primary200: palette.primary200,
        primary300: palette.primary300,
        primary400: palette.primary400,
        primary500: palette.primary500,
        primary600: palette.primary600,
        primary700: palette.primary700
    });
const space = {
    scale0: "2px",
    scale100: "4px",
    scale200: "6px",
    scale300: "8px",
    scale400: "10px",
    scale500: "12px",
    scale550: "14px",
    scale600: "16px",
    scale650: "18px",
    scale700: "20px",
    scale750: "22px",
    scale800: "24px",
    scale850: "28px",
    scale900: "32px",
    scale950: "36px",
    scale1000: "40px",
    scale1200: "48px",
    scale1400: "56px",
    scale1600: "64px",
    scale2400: "96px",
    scale3200: "128px",
    scale4800: "192px"
};
const radii = {
    radius100: "2px",
    radius200: "4px",
    radius300: "8px",
    radius400: "12px"
};


/***/ }),

/***/ 44122:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  w: () => (/* binding */ KeyNormalizedControl)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/styles/styled.js
var styled = __webpack_require__(10334);
// EXTERNAL MODULE: ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/index.js + 13 modules
var es = __webpack_require__(25438);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-hotkeys-ce@2.0.6_react@0.0.0-experimental-4ead6b530/node_modules/react-hotkeys-ce/index.es.js
var index_es = __webpack_require__(26722);
// EXTERNAL MODULE: ../@gadgetinc/errors/index.ts
var errors = __webpack_require__(24818);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/toast/toaster.js + 2 modules
var toaster = __webpack_require__(95150);
;// CONCATENATED MODULE: ../@gadgetinc/widgets/src/utils/feedback.tsx


const messageWithoutCode = (message)=>{
    return message.substring(message.indexOf(":") + 1);
};
const tryWithUserFeedback = (action)=>{
    try {
        action();
    } catch (error) {
        if (error instanceof errors/* UserInitiatedActionSemanticError */.fE) {
            toaster/* default */.Z.negative(messageWithoutCode(error.message), {
                autoHideDuration: 3000
            });
        } else {
            throw error;
        }
    }
};

;// CONCATENATED MODULE: ../@gadgetinc/widgets/src/utils/KeyNormalizedControl.tsx





const KeyNormalizedControl = (0,es/* observer */.Pi)((props)=>{
    const [, $theme] = (0,styled/* useStyletron */.hQ)();
    const ignoreKeyProps = {
        ...props.ignoreKeyProps ?? {}
    };
    const hotKeyProps = {
        handlers: {},
        keyMap: {}
    };
    const baseExceptions = [
        "escape",
        "meta",
        "ctrl",
        "shift",
        "p",
        "k"
    ];
    if (props.mode == "form") {
        ignoreKeyProps.only = [
            "up",
            "down",
            "left",
            "right",
            "enter",
            "space",
            "Delete",
            "backspace"
        ];
    } else if (props.mode == "simple") {
        ignoreKeyProps.only = [
            "enter",
            "space"
        ];
    } else if (props.mode == "select") {
        ignoreKeyProps.except = baseExceptions;
    } else if (props.mode == "textarea") {
        ignoreKeyProps.except = baseExceptions;
    } else if (props.engagementBoundary) {
        ignoreKeyProps.except = [
            ...baseExceptions,
            "up",
            "down"
        ];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        hotKeyProps.keyMap["FINISHED_EDITING"] = [
            "enter"
        ];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        hotKeyProps.handlers["FINISHED_EDITING"] = (event)=>{
            event?.preventDefault();
            tryWithUserFeedback(()=>props.onFinish?.());
        };
    } else {
        ignoreKeyProps.except = [
            ...baseExceptions,
            "up",
            "down",
            "enter"
        ];
    }
    const innerContent = /*#__PURE__*/ react.createElement(index_es.IgnoreKeys, ignoreKeyProps, props.children);
    return props.hasHotKeys ? /*#__PURE__*/ react.createElement(index_es.HotKeys, {
        ...hotKeyProps,
        style: {
            minHeight: "32px"
        }
    }, innerContent) : innerContent;
});


/***/ }),

/***/ 77886:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Yh: () => (/* binding */ MultiEnvironmentDocsVersion),
/* harmony export */   km: () => (/* binding */ ActionsAsCodeDocsVersion),
/* harmony export */   uY: () => (/* binding */ DefaultDocsVersion),
/* harmony export */   zh: () => (/* binding */ DocsVersions)
/* harmony export */ });
const DocsVersions = [
    {
        id: "actions-as-code",
        prefix: "/v0",
        rootURL: "/v0/",
        dir: "docs/pages/guides/2-actions-as-code",
        frameworkRange: "<=0.3.1",
        label: "v0"
    },
    {
        id: "multi-env",
        prefix: "",
        rootURL: "/",
        dir: "docs/pages/guides/3-multi-env",
        frameworkRange: ">=1.0.0",
        label: "v1"
    }
];
const MultiEnvironmentDocsVersion = DocsVersions[1];
const ActionsAsCodeDocsVersion = DocsVersions[0];
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const DefaultDocsVersion = DocsVersions.find((version)=>version.prefix == "");


/***/ }),

/***/ 5994:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DB: () => (/* binding */ legacyEnvironmentNameMatchesType),
/* harmony export */   Hk: () => (/* binding */ legacyEnvironmentNameToEnvironmentSlug),
/* harmony export */   KG: () => (/* binding */ ProductionEnvironmentName),
/* harmony export */   Qj: () => (/* binding */ EnvironmentType),
/* harmony export */   Sk: () => (/* binding */ EnvironmentNameMSTType),
/* harmony export */   a2: () => (/* binding */ EnvironmentStatus),
/* harmony export */   am: () => (/* binding */ EnvironmentTypeMSTType),
/* harmony export */   g7: () => (/* binding */ DevelopmentEnvironmentSlug),
/* harmony export */   gq: () => (/* binding */ EnvironmentNames),
/* harmony export */   qT: () => (/* binding */ legacyEnvironmentNameToEnvironmentType),
/* harmony export */   wv: () => (/* binding */ isEnvironmentName),
/* harmony export */   x0: () => (/* binding */ ProductionEnvironmentSlug),
/* harmony export */   y2: () => (/* binding */ DevelopmentEnvironmentName)
/* harmony export */ });
/* unused harmony exports environmentTypeToLegacyEnvironmentName, environmentTypeToNodeEnv */
/* harmony import */ var _gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48005);
/* harmony import */ var _gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__);

var EnvironmentStatus;
(function(EnvironmentStatus) {
    EnvironmentStatus["PENDING"] = "pending";
    EnvironmentStatus["ACTIVE"] = "active";
    EnvironmentStatus["PAUSED"] = "paused";
    EnvironmentStatus["FATAL_ERROR"] = "fatal_error";
})(EnvironmentStatus || (EnvironmentStatus = {}));
var EnvironmentType;
(function(EnvironmentType) {
    /**
   * An environment for internal platform use, hidden from the user. Suitable for running versions of the app to test the app, like for unit tests or AI app summoning verification. Test environments are ephemeral, and can be deleted at any time.
   **/ EnvironmentType["Test"] = "test";
    /**
   * An environment created by a user where development happens. Optimized for responsiveness to the developer and feedback
   **/ EnvironmentType["Development"] = "development";
    /**
   * The environment of the app where end users interact with the application. Optimized for scale and stability.
   **/ EnvironmentType["Production"] = "production";
})(EnvironmentType || (EnvironmentType = {}));
const DevelopmentEnvironmentSlug = "development";
const ProductionEnvironmentSlug = "production";
const DevelopmentEnvironmentName = "Development";
const ProductionEnvironmentName = "Production";
const EnvironmentNames = [
    DevelopmentEnvironmentName,
    ProductionEnvironmentName
];
const isEnvironmentName = (environmentName)=>EnvironmentNames.includes(environmentName);
const EnvironmentNameMSTType = _gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.optional(_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.frozen(), DevelopmentEnvironmentName);
const EnvironmentTypeMSTType = _gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.optional(_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.enumeration(Object.values(EnvironmentType)), "development");
const legacyEnvironmentNameMatchesType = (envName, environmentType)=>{
    return envName === DevelopmentEnvironmentName && environmentType === "development" || envName === ProductionEnvironmentName && environmentType === "production";
};
const legacyEnvironmentNameToEnvironmentType = (envName)=>{
    if (envName === DevelopmentEnvironmentName) {
        return "development";
    } else if (envName === ProductionEnvironmentName) {
        return "production";
    } else {
        throw new Error(`Unknown environment name ${envName}`);
    }
};
const environmentTypeToLegacyEnvironmentName = (environmentType)=>{
    if (environmentType === "development" || environmentType === "test") {
        return DevelopmentEnvironmentName;
    } else if (environmentType === "production") {
        return ProductionEnvironmentName;
    } else {
        throw new Error(`Unknown environment type ${environmentType}`);
    }
};
const legacyEnvironmentNameToEnvironmentSlug = (envName)=>{
    if (envName === DevelopmentEnvironmentName) {
        return DevelopmentEnvironmentSlug;
    } else if (envName === ProductionEnvironmentName) {
        return ProductionEnvironmentSlug;
    } else {
        throw new Error(`Unknown environment name ${envName}`);
    }
};
const environmentTypeToNodeEnv = (environmentType)=>{
    switch(environmentType){
        case "test":
            return "test";
        case "development":
            return "development";
        case "production":
            return "production";
    }
};


/***/ })

}]);